import React from "react";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import useAuth from "src/hooks/useAuth";
import SplitActionButton, {
  splitActionButtonStyles,
} from "src/components/buttons/SplitActionButton";

export default function PickingActionButtons({
  isKit,
  loading,
  settings,
  currentItem,
  handlePickKit,
  setOpenScanModal,
  markItemAsPicked,
  onOverridePickLocations,
}) {
  const { user } = useAuth();
  const isAdminOrManager = ["admin", "manager"].includes(user.role);

  if (isKit) {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={() => handlePickKit(currentItem.asset.id, currentItem.rackLocations, currentItem)}
      >
        Pick Kit
      </Button>
    );
  }

  if (settings.scan_out_modal) {
    return (
      <Button
        variant="contained"
        color="primary"
        startIcon={loading && <CircularProgress size={22} />}
        onClick={() => setOpenScanModal(true)}
        disabled={loading}
      >
        Scan Out
      </Button>
    );
  }

  if (!isAdminOrManager) {
    return (
      <Button
        variant="contained"
        color="primary"
        startIcon={loading && <CircularProgress size={22} />}
        onClick={markItemAsPicked}
        disabled={loading}
      >
        Mark as Picked
      </Button>
    );
  }

  return (
    <SplitActionButton
      renderMenuItems={popupState => (
        <MenuItem
          onClick={() => {
            popupState.close();
            if (onOverridePickLocations) {
              onOverridePickLocations(currentItem);
            }
          }}
        >
          Override Pick Locations
        </MenuItem>
      )}
    >
      <Button
        sx={splitActionButtonStyles.button}
        variant="contained"
        color="primary"
        startIcon={loading && <CircularProgress size={22} />}
        onClick={markItemAsPicked}
        disabled={loading}
      >
        Mark as Picked
      </Button>
    </SplitActionButton>
  );
}
